import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import { getContrastingColor } from "../../../utils/functionUltils";

const nameHeaderBlocks = t("Giới thiệu chung", "Giới thiệu chung");
const commonMedia =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M16.725 19.5q-.3-.125-.563-.263t-.537-.337l-1.075.325q-.175.05-.325-.013t-.25-.212l-.6-1q-.1-.15-.05-.325t.175-.3l.825-.725q-.05-.3-.05-.65t.05-.65l-.825-.725q-.125-.125-.175-.3t.05-.325l.6-1q.1-.15.25-.212t.325-.013l1.075.325q.275-.2.537-.337t.563-.263l.225-1.1q.05-.175.163-.288t.312-.112h1.2q.2 0 .313.113t.162.287l.225 1.1q.3.125.563.263t.537.337l1.075-.325q.175-.05.325.013t.25.212l.6 1q.1.15.05.325t-.175.3l-.825.725q.05.3.05.65t-.05.65l.825.725q.125.125.175.3t-.05.325l-.6 1q-.1.15-.25.213t-.325.012l-1.075-.325q-.275.2-.537.338t-.563.262l-.225 1.1q-.05.175-.163.288t-.312.112h-1.2q-.2 0-.313-.113t-.162-.287l-.225-1.1Zm1.3-1.5q.825 0 1.413-.588T20.025 16q0-.825-.587-1.413T18.025 14q-.825 0-1.412.588T16.024 16q0 .825.588 1.413t1.412.587ZM5 20q-.825 0-1.412-.588T3 18V4q0-.825.588-1.413T5 2h14q.825 0 1.413.588T21 4v5.65q-.475-.225-.975-.363T19 9.075V4H5v9h3.55q.3 0 .525.138t.35.362q.35.575.775.9t.925.475q-.225 1.35.063 2.675T12.275 20H5Z"/></svg>';

export const generalHeaderIntroduction = (
  data?: any,
  color?: string,
  height?: string
) => {
  const blockUI = {
    id: "header-block-id",
    label: t("Phần đầu", "Phần đầu"),
    css: "",
    content: "",
    media: commonMedia,
    category: nameHeaderBlocks,
  };
  const textColor = color ? getContrastingColor(color) : "#000000";
  const logo = data?.logo;
  const name = data?.name

  blockUI.content = `
  <section id="izqjjv" class="text-gray-600 body-font">
   <header 
  style="
    background-color: ${color || "#b40e0e"}; 
    color: ${textColor}; 
    height: ${height || "auto"}; 
    padding: 10px 80px;"
  id="i1z3t" 
  component-class="HeaderBlog"
  class="flex">
      <div id="ibtwy" class="flex flex-wrap justify-between w-full flex-col md:flex-row items-center gap-10	" >
      <div class="flex gap-10">
       <div component-class="LinkDetailSchool" class="flex items-center gap-3">
        <div component-class="universityLogo"><img id="i2fag" src=${logo} class="w-8"/></div>
        <div component-class="universityName" style="font-size: 18px; font-family: 'Inter-bold';">${name}</div>
      </div>
        <div id="ie4ll" class="md:mr-autoflex-wrap items-center text-base justify-center flex">
          <ul class="py-2 flex">
            <li class="relative group">
              <b id="i067i" class="text-white text-sm p-6 pointer">${t("Khám phá", "Khám phá")}</b>
              <div class="absolute left-0 mt-2 w-60 bg-white shadow-md rounded border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-300 z-10 w-max-content">
                <ul class="py-2" component-class="DiscoverLinks"
                style = "min-width: 246px"
                >
                  <li>
                    <a href="#" class="block px-4 py-2 text-gray-700 font-semibold">${t("Danh sách khoá học", "Danh sách khoá học")}</a>
                  </li>
                  <li>
                    <a href="#" class="block px-4 py-2 text-gray-700 font-semibold">${t("Danh sách chương trình học", "Danh sách chương trình học")}</a>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <b id="i722x" class="text-white text-sm p-6 pointer" component-class="BlogHeaderLink" Uuid="${data}">Blog</b> 
            </li>
          </ul>   
        </div>
      </div>
        <div component-class="HeaderLoginDiv" class ="flex gap-2">
  <button
   id="i37d7-2" 
   style="
     background: ${color};
     border: 1px solid #fff;
     color: #fff;
     height: 48px;
     border-radius: 8px;
     padding: 0 16px;
     display: inline-flex;
     align-items: center;
     justify-content: center;
     text-decoration: none;
     transition: all 0.3s ease-in-out;"
   onmouseover="this.style.background='#fff'; this.style.color='${color}';"
   onmouseout="this.style.background='${color}'; this.style.color='#fff';">
   ${t("Đăng nhập", "Đăng nhập")}
</button>
<button
   id="i37d7-2" 
   style="
     background: ${color};
     border: 1px solid #fff;
     color: #fff;
     height: 48px;
     border-radius: 8px;
     padding: 0 16px;
     display: inline-flex;
     align-items: center;
     justify-content: center;
     text-decoration: none;
     transition: all 0.3s ease-in-out;"
   onmouseover="this.style.background='#fff'; this.style.color='${color}';"
   onmouseout="this.style.background='${color}'; this.style.color='#fff';">
   ${t("Đăng ký", "Đăng ký")}
</button>
        </div>
      </div>
    </header>
  </section>
  `;

  return blockUI;
};
